import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { motion } from "framer-motion";

import { colors } from "UI/colors";

FnrProgressBar.propTypes = {
  count: PropTypes.number,
  max: PropTypes.number,
  delay: PropTypes.number,
  maxBarStyle: PropTypes.object,
  countBarStyle: PropTypes.object,
};

export default function FnrProgressBar({
  count,
  max,
  delay = 0,
  maxBarStyle,
  countBarStyle,
}) {
  const getWidth = () => {
    const width = (count / max) * 100;

    if (!width || width < 0) return "0";
    else if (width > 100) return "100%";
    else return `${width}%`;
  };

  const progressBarAnimation = {
    width: getWidth(),
    transition: {
      delay: delay,
    },
  };

  return (
    <Wrapper>
      <MaxBar style={maxBarStyle} />
      <CountBar animate={progressBarAnimation} style={countBarStyle} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
`;

const Bar = styled(motion.div)`
  position: absolute;
  left: 0;
  top: 0;
  height: 8px;
  border-radius: 10px;
`;

const CountBar = styled(Bar)`
  background-color: ${colors.fnBlue};
`;

const MaxBar = styled(Bar)`
  right: 0;
  background-color: #ddd;
`;
